import * as React from 'react';
export const RefContext = /*#__PURE__*/React.createContext({});